// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2H-3d","colBig":"styles_colBig__3kc5D","colSmall":"styles_colSmall__20brh","shopifyNameWrapper":"styles_shopifyNameWrapper__tjQx8"};